import React from 'react';

import { defaultPageWrapper } from '../wrappers/defaultPageWrapper';
import Spinner from './Spinner';


class LoadingPage extends React.Component {
  render() {
    return (
      <div style={{
        margin: '100px 50%'
      }}>
        <Spinner height="50px" />
      </div>
    );
  }
};

const WrappedLoadingPage = defaultPageWrapper(LoadingPage, false);

export default WrappedLoadingPage;


// WEBPACK FOOTER //
// ./src/components/misc/Loading.jsx